const Rb2b = {
  mounted() {
    const key = this.el.dataset.key;
    if (!key || window.reb2b) return;

    window.reb2b = { loaded: true };
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://ddwl4m2hdecbv.cloudfront.net/b/${key}/${key}.js.gz`;
    const first = document.getElementsByTagName('script')[0];
    first.parentNode.insertBefore(script, first);
  },
};

export default { Rb2b };
